import _ from 'lodash'
import parseTouts from './parseTouts'
import { areTagsValidForThisGame } from '../utils'
import { config } from './../../components/Init/Init'

function _filterCategoriesForGameTags(lobbyGameTouts, playerGameTags) {
  return _.remove(lobbyGameTouts, tout => {
    return tout.game[0] && !areTagsValidForThisGame(playerGameTags, tout.game[0])
  })
}

function _getSubcategoriesGameIds(gameCategorySubcategories, categories) {
  const subcategoriesGameIds = []

  if (gameCategorySubcategories) {
    gameCategorySubcategories.forEach(subcategory => {
      const subcategoryData = _.find(categories, {
        lobbyGameCategory: [{ gameCategoryId: parseInt(subcategory) }]
      })

      if (subcategoryData && subcategoryData.lobbyGameTouts.length !== 0) {
        // unique subCategory gameIds
        const toutIds = _.chain(subcategoryData.lobbyGameTouts)
          .flatMap('game')
          .map('gameId')
          .uniq()
          .value()

        subcategoriesGameIds.push(...toutIds)
      }
    })
  }

  return subcategoriesGameIds
}

function _isFullyLoaded(category, subcategoriesIds, categories, lazyLoadedCategoryIds) {
  if (category._count > config.lobbyPaginationInitialLimit && !lazyLoadedCategoryIds.includes(category.id)) {
    return false
  }
  if (!subcategoriesIds) {
    return true
  }
  let isAllSubcategoryFullyLoaded = true
  subcategoriesIds.forEach(subcategoryId => {
    const subcategoryData = _.find(categories, {
      lobbyGameCategory: [{ gameCategoryId: parseInt(subcategoryId) }]
    })
    let subcategoriesOfSubcategory = []
    if (
      subcategoryData &&
      subcategoryData.lobbyGameCategory &&
      subcategoryData.lobbyGameCategory[0] &&
      subcategoryData.lobbyGameCategory[0].gameCategorySubcategories
    ) {
      subcategoriesOfSubcategory = subcategoryData.lobbyGameCategory[0].gameCategorySubcategories
    }
    if (
      subcategoryData &&
      !_isFullyLoaded(subcategoryData, subcategoriesOfSubcategory, categories, lazyLoadedCategoryIds)
    ) {
      isAllSubcategoryFullyLoaded = false
    }
  })

  return isAllSubcategoryFullyLoaded
}

function _getCategoriesGameIds(lobbyGameTouts) {
  return _.chain(lobbyGameTouts)
    .flatMap('game')
    .map('gameId')
    .uniq()
    .value()
}

function _getSubcategories(gameCategorySubcategories) {
  return _.chain(gameCategorySubcategories)
    .filter(subcategory => subcategory && _.isFinite(parseInt(subcategory.subcategoryId)))
    .map(subcategory => parseInt(subcategory.subcategoryId))
    .value()
}

function _getSecondLevelSubcategories(subcategories, categories) {
  let secondLevelSubcategories = []
  subcategories.map(s => {
    const subcategoryData = _.find(categories, {
      lobbyGameCategory: [{ gameCategoryId: parseInt(s) }]
    })
    if (
      subcategoryData &&
      subcategoryData.lobbyGameCategory &&
      subcategoryData.lobbyGameCategory[0] &&
      subcategoryData.lobbyGameCategory[0].gameCategorySubcategories &&
      subcategoryData.lobbyGameCategory[0].gameCategoryDisplayType === config.categoryDisplayTypes.subCategory
    ) {
      const subcategoriesIds = _getSubcategories(subcategoryData.lobbyGameCategory[0].gameCategorySubcategories)
      secondLevelSubcategories = secondLevelSubcategories.concat(subcategoriesIds)
    }
  })
  return secondLevelSubcategories
}

function _getCategoriesCountsCache() {
  const categoriesCountsItem = sessionStorage.getItem('categoriesCounts')
  let categoriesCounts = {}
  if (categoriesCountsItem) {
    let parsedCategoriesCountsItem = JSON.parse(categoriesCountsItem)
    if (parsedCategoriesCountsItem && typeof parsedCategoriesCountsItem === 'object') {
      categoriesCounts = parsedCategoriesCountsItem
    }
  }
  return categoriesCounts
}

function parseCategories(categories, playerGameTags, lazyLoadedCategoryIds) {
  const filteredCategories = categories.filter(category => category.lobbyGameCategory.length !== 0)

  if (config.filterGamesForPlayerTags) {
    let tagsToFilterAgainst = playerGameTags ? playerGameTags : '[]'
    _.map(filteredCategories, category => {
      if (category.lobbyGameTouts && category.lobbyGameTouts.length > 0) {
        // The _count and lobbyGameTouts.length may not be the same value
        // Only adjust the _count value by the change in lobbyGameTouts.length
        let currentNumberOfGameTouts = category.lobbyGameTouts.length
        _filterCategoriesForGameTags(category.lobbyGameTouts, tagsToFilterAgainst)
        if (currentNumberOfGameTouts !== category.lobbyGameTouts.length) {
          category._count -= currentNumberOfGameTouts - category.lobbyGameTouts.length
        }
      }
    })
  }

  return _.map(filteredCategories, category => {
    const c = category.lobbyGameCategory[0]

    // unique category gameIds
    const categoryGameIds = _getCategoriesGameIds(category.lobbyGameTouts)

    const subcategories = _getSubcategories(c.gameCategorySubcategories)

    // unique subcategories gameIds
    const subcategoriesGameIds = _getSubcategoriesGameIds(subcategories, filteredCategories)

    const secondLevelSubcategories = _getSecondLevelSubcategories(subcategories, filteredCategories)

    // unique second level subcategories gameIds
    const secondLevelSubcategoriesGameIds = _getSubcategoriesGameIds(secondLevelSubcategories, filteredCategories)

    const touts = category.lobbyGameTouts ? parseTouts(category.lobbyGameTouts) : []
    let totalCountWithSubcategories = null
    if (_isFullyLoaded(category, subcategories, filteredCategories, lazyLoadedCategoryIds)) {
      totalCountWithSubcategories = _.union(categoryGameIds, subcategoriesGameIds, secondLevelSubcategoriesGameIds)
        .length
      if (config.enableCategoryGameCountsCache) {
        const categoriesCounts = _getCategoriesCountsCache()
        if (categoriesCounts[c.slug] !== totalCountWithSubcategories) {
          categoriesCounts[c.slug] = totalCountWithSubcategories
          sessionStorage.setItem('categoriesCounts', JSON.stringify(categoriesCounts))
        }
      }
    } else {
      if (config.enableCategoryGameCountsCache) {
        const categoriesCounts = _getCategoriesCountsCache()
        if (categoriesCounts[c.slug] && Number(categoriesCounts[c.slug])) {
          totalCountWithSubcategories = Number(categoriesCounts[c.slug])
        }
      }
    }

    let jackpot = {}
    if (_.get(category, 'lobbyJackpot[0]')) {
      jackpot.backgroundImg = _.get(category, 'lobbyJackpot[0].jackpotBackgroundImage[0].url')
      jackpot.backgroundImgMobile = _.get(category, 'lobbyJackpot[0].jackpotBackgroundImageMobile[0].url')
      jackpot.games = _.get(category, 'lobbyJackpot[0].jackpotGames')
    }

    let featuredLayout
    if (c.gameCategoryTemplate === config.templateNames.featured) {
      try {
        featuredLayout = JSON.parse(c.gameCategoryCustomLayout)
      } catch (e) {
        console.log(`Error occurred parsing Custom Layout for "${c.slug}" category: "${e}"`)
      }
    }

    return {
      touts,
      subcategories,
      totalCountWithSubcategories,
      title: c.title,
      cmsId: category.id,
      id: c.gameCategoryId,
      totalCount: category._count,
      name: c.gameCategoryName,
      template: c.gameCategoryTemplate,
      displayType: c.gameCategoryDisplayType,
      featuredLayout,
      description: c.gameCategoryDescription,
      descriptionTitle: c.gameCategoryDescriptionTitle,
      jackpot
    }
  })
}

export default parseCategories
